// extracted by mini-css-extract-plugin
export default {"hotspotCone":"HotspotCone_hotspotCone__o+3u9"};